class FostrAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.speed = (this.dataset.speed * 1000) || 4000;
    this.slidesContainer = this.querySelector('.fostr-announcement-bar__slides');
    this.slidesContainer.addEventListener('mouseenter', this.pauseSlide.bind(this));
    this.slidesContainer.addEventListener('mouseleave', this.resumeSlide.bind(this));

    // Create a section observer to this element comes in and out of view
    const sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // add class to body
          document.body.classList.add('announcement-bar--in-view');
        } else {
          document.body.classList.remove('announcement-bar--in-view');
        }
      });
    }, {
      rootMargin: '0px 0px -50% 0px'
    });

    // Observe the section
    sectionObserver.observe(this);

    // get slides as a new created element
    const duplicateSlidesEl = document.createElement('div');
    duplicateSlidesEl.innerHTML = this.slidesContainer.innerHTML;
    duplicateSlidesEl.innerHTML += this.slidesContainer.innerHTML;

    // loop through all li items in duplicateSlidesEl and add class
    const duplicateSlides = duplicateSlidesEl.querySelectorAll('li');
    duplicateSlides.forEach((slide, index) => {
      // update aria-roledescription, id, and aria-label attributes
      slide.setAttribute('aria-roledescription', `Slide ${index}`);
      slide.setAttribute('id', `fostr-announcement-bar__slide-${index}`);
      slide.setAttribute('aria-label', `Slide ${index + 1} of ${duplicateSlides.length}`);
    });

    // Clear the slidesContainer and append the modified duplicated slides
    this.slidesContainer.innerHTML = '';
    duplicateSlides.forEach(slide => {
      this.slidesContainer.appendChild(slide);
    });

    this.slides = this.querySelectorAll('.fostr-announcement-bar__slide');
    this.totalSlides = this.slides.length;

    // Set the index of the current slide and the time interval for sliding
    this.currentIndex = 0;
    this.slideInterval = null;
    this.isPaused = false;

    // Set the slide interval
    this.slideInterval = setInterval(() => {
      this.slideNext();
    }, this.speed);

    // Create the start/stop button
    this.toggleButton = document.createElement('button');
    this.toggleButton.textContent = 'Pause Slide';
    this.toggleButton.style.border = '0';
    this.toggleButton.style.clip = 'rect(0, 0, 0, 0)';
    this.toggleButton.style.height = '1px';
    this.toggleButton.style.margin = '-1px';
    this.toggleButton.style.overflow = 'hidden';
    this.toggleButton.style.padding = '0';
    this.toggleButton.style.width = '1px';
    
    this.appendChild(this.toggleButton);

    // Add event listener to toggle slide
    this.toggleButton.addEventListener('click', this.toggleSlide.bind(this));
  }

  disconnectedCallback() {
    clearInterval(this.slideInterval);
  }

  slideNext() {
    if (this.currentIndex === this.totalSlides - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }

    if (this.currentIndex > this.totalSlides / 2) {
      this.currentIndex = 0;
      clearInterval(this.slideInterval);
      this.slidesContainer.style.scrollBehavior = 'instant !important';
      this.slidesContainer.scrollLeft = this.slides[this.currentIndex].offsetLeft;
      this.slidesContainer.style.scrollBehavior = '';
      this.slideInterval = setInterval(() => {
        this.slideNext();
      }, this.speed);
    } else {
      this.slidesContainer.scroll({
        left: this.slides[this.currentIndex].offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  pauseSlide() {
    clearInterval(this.slideInterval);
    this.isPaused = true;
  }

  resumeSlide() {
    if (this.isPaused) {
      this.slideInterval = setInterval(() => {
        this.slideNext();
      }, this.speed);
      this.isPaused = false;
    }
  }

  toggleSlide() {
    if (this.isPaused) {
      this.resumeSlide();
      this.toggleButton.textContent = 'Pause Slide';
    } else {
      this.pauseSlide();
      this.toggleButton.textContent = 'Resume Slide';
    }
  }
}

// Define the custom element
customElements.define('fostr-announcement-bar', FostrAnnouncementBar);
